import { Stack, Typography } from '@mui/material';

export interface ContractDataItemProps {
  subText?: string;
  text: string;
  label: string;
}

export const ContractDataItem = (props: ContractDataItemProps) => {
  const { label, text, subText } = props;

  return (
    <Stack spacing={1}>
      <Typography variant="detailLabel">{label}</Typography>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Typography variant="detailText">{text}</Typography>
        {subText ? (
          <Typography variant="detailSubText">({subText})</Typography>
        ) : null}
      </Stack>
    </Stack>
  );
};

ContractDataItem.defaultProps = { subText: '' };
